<template>

	<div>
		<!-- <headlink></headlink>-->
		<headlink v-if="parent == '0'"></headlink>
		<headlink1 v-if="parent == '1'"></headlink1>
		<div class="ui-flex ui-flex-pack-center" style="height:auto;">
			<div style=" height: 880px; width:100%;" id="allmap">

			</div>
		</div>
		<div id="r-result" style="display: none;">
			<div class="optionpanel">
				<label>选择主题</label>
				<select id="stylelist" onchange="changeMapStyle(this.value)"></select>
			</div>

		</div>
	</div>

</template>

<script>
	import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'
	import BMap from 'BMap'
	import BMapSymbolSHAPEPOINT from 'BMap_Symbol_SHAPE_POINT'
	export default {

		name: 'baidu',

		data() {
			return {
				parent: "0"
			}
		},

		mounted: function() {
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			var parent = history.getItem("parent");
			this.parent = parent;

			var bm = new BMap.Map("allmap");
			bm.addControl(new BMap.NavigationControl());
			bm.enableScrollWheelZoom();
			bm.enableContinuousZoom();
			var sel = document.getElementById('stylelist');
			for(var key in mapstyles) {
				var style = mapstyles[key];
				var item = new Option(style.title, key);
				sel.options.add(item);
			}
			changeMapStyle('normal')
			sel.value = 'normal';

			function changeMapStyle(style) {

				bm.setMapStyle({
					style: style
				});
				$('#desc').html(mapstyles[style].desc);
			}

			$.ajax({
				type: "post",
				url: "http://localhost:8080/ZYun/HttpService.do",
				contentType: "application/json; charset=utf-8",
				async: true,
				data: JSON.stringify(getJsonData()),
				dataType: 'json',
				success: function(data) {

					$.each(data.eqList, function(index, value) {
						var pointArr = [];

						var eqIp = value.eqIp;
						console.log(eqIp);
						if(value.eqLon != null && value.eqLat != null) {

							var eqName = value.eqName;
							//谷歌坐标
							var x = value.eqLon;
							var y = value.eqLat;
							var coords = x + ',' + y;
							//Ajax 跨域请求问题设置
							$.ajax({
								type: "get",
								dataType: 'jsonp',
								processData: false,
								url: "http://api.map.baidu.com/geoconv/v1/?coords=" + coords + "&from=3&to=5&output=json&ak=PnOLHS34HgAmAEyKylVyecVz0Q2lnZmZ",
								async: true,
								success: function(date) {
									var point = new BMap.Point(date.result[0].x, date.result[0].y);
									var icon;
									bm.centerAndZoom(point, 15);
									if(value.eqState == 0) {
										if(value.eqType == 11) {
											var icon = new BMap.Icon('/static/img/siludingweihongditu.png', new BMap.Size(30, 30));
										} else if(value.eqType == 5) {
											var icon = new BMap.Icon('/static/img/dingwei_hongditu.png', new BMap.Size(25, 25));
										} else if(value.eqType == 6) {
											var icon = new BMap.Icon('/static/img/danludingweihongditu.png', new BMap.Size(25, 25));
										}

									} else {
										if(value.eqType == 11) {
											var icon = new BMap.Icon('/static/img/siludingweilvditu.png', new BMap.Size(30, 30));
										} else if(value.eqType == 5) {
											var icon = new BMap.Icon('/static/img/dingwei_lvditu.png', new BMap.Size(25, 25));
										} else if(value.eqType == 6) {
											var icon = new BMap.Icon('/static/img/danludingweilvditu.png', new BMap.Size(25, 25));
										}

									}

									var marker = new BMap.Marker(point, {
										icon: icon
									}); // 创建标注

									var opts = {
										position: point, // 指定文本标注所在的地理位置
										offset: new BMap.Size(20, -10) //设置文本偏移量 
									}

									var label = new BMap.Label(value.eqName, opts);
									marker.setLabel(label);

									label.setStyle({
										color: "Block",
										backgroundColor: "red",
										fontSize: "15px",
										height: "0px",
										lineHeight: "0px",
										fontFamily: "微软雅黑"
									});
									marker.setAnimation(BMAP_ANIMATION_BOUNCE);
									bm.addOverlay(marker);
									//					   marker.setLabel(new BMap.Label(eqName));

									//			 	 		 var contet="<p>设备名称"+value.eqName+"</p>";
									//             		var infowindow = new BMap.InfoWindow(contet);	
									//                     marker.openInfoWindow(infowindow);

									(function() {
										var thePoint = value.eqId;
										marker.addEventListener("click", function() {
											fanhui(thePoint);
										});
									})();

								},
								error: function(XMLHttpRequest, textStatus, errorThrown) {
									console.log(XMLHttpRequest.status);
									console.log(XMLHttpRequest.readyState);
									console.log(textStatus);
								}
							});
						}

					});
				}
			});

			//dfasfd
			function getJsonData() {
				const history = window.sessionStorage;
				var uid = history.getItem("user");

				var json = {
					"serviceCode": "1012",
					"uId": uid
				}
				return json;
			}

			function fanhui(eqId) {

				window.location.href = "http://localhost:8080/#/devicemanage?tiaozhuan=" + eqId;

			}

		},

		components: {
			headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/baidu/baidu.vue